import { render, staticRenderFns } from "./PageBasePc.vue?vue&type=template&id=3d66eb51&scoped=true&"
import script from "./PageBasePc.vue?vue&type=script&lang=js&"
export * from "./PageBasePc.vue?vue&type=script&lang=js&"
import style0 from "./PageBasePc.vue?vue&type=style&index=0&id=3d66eb51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d66eb51",
  null
  
)

export default component.exports